var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-tips"},[(_vm.isPremiumUser)?_c('TipsPremium'):_c('TipsFree')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }